import axios from 'axios';
import { useFlags } from 'launchdarkly-react-client-sdk';

const contentType = 'application/json';

export const VoeBizApi = () => {
  const ldFlags = useFlags();
  const { apiDomain } = ldFlags;

  return {
    getTopics: async () => {
      return axios
        .get(`${apiDomain}/attendance/v1/frequentlyQuestions`, {
          headers: {
            'Content-Type': contentType,
          },
        })
        .then((response) => {
          return { success: true, response: response.data };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },
  };
};
